import { useContext } from "react";

import { ExternalAuthContext } from "@/services/ExternalAuthProvider";

export default function useAuth() {
  const {
    isAuthenticated,
    isLoading,
    getToken,
    saveToken,
    logout,
    login,
    register,
    permissions,
    user,
    isAuthenticationRequired,
    kindeGetPermissions,
    kindeGetClaim,
    kindeRefreshToken,
  } = useContext(ExternalAuthContext);

  return {
    isAuthenticated,
    isLoading,
    getToken,
    logout,
    login,
    saveToken,
    register,
    permissions,
    user,
    isAuthenticationRequired,
    kindeGetPermissions,
    kindeGetClaim,
    kindeRefreshToken,
  };
}
